module.exports = __webpack_public_path__ + "img/course1.f7242453.png";